import { UserIdEnum } from '@/enums/UserIdEnum'
import { UserCustomerTypeEnum } from '@/gen/ecom-asm'
import { getAsmSession } from '@/helpers/getAsmSession'

import type { Session } from 'next-auth'
import type { UserId } from '@/interfaces/UserId'

export function getUserId(session?: Session | null, serverCookies?: string): UserId {
  const asmSession = getAsmSession(serverCookies)

  const impersonatedUid = asmSession?.impersonatedUser?.uid

  if (session?.user?.customerType === UserCustomerTypeEnum.Employee.toLocaleLowerCase() && impersonatedUid) {
    return impersonatedUid
  }

  return session?.id ?? UserIdEnum.Anonymous
}
